import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export type LookupParams = z.infer<typeof lookupOrder.input>;

export const lookupOrder = {
  name: "lookupOrder" as const,
  input: z.object({
    orderName: z.string().nullish(),
    orderId: z.string().nullish(),
  }),
  output: z
    .object({
      _id: zExt.objectId(),
      fulfillmentGroupId: zExt.objectId().nullish(),
    })
    .nullable(),
};
